import { app } from '../../../../bootstrap/core';
import { partnerItemComponent } from './partnerItem.component';

app.component('partnerItem', partnerItemComponent);
